'use client' // Error boundaries must be Client Components

import { ErrorPage } from 'components/error.page'
import { captureException } from '@tucan/utils/error-tracking'
import { useEffect } from 'react'

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureException(error)
  }, [error])

  return <ErrorPage code={500} />
}
